import { z } from 'zod'

export const youTubeTagsResponseBody = z.array(z.object({ name: z.string() }))

export type YouTubeTagsResponseBody = z.infer<typeof youTubeTagsResponseBody>
